import { Stack } from "@mui/material";
import { type FC } from "react";

import { FAQAccordion } from "~/components/FAQAccordion";
import { EventSectionTitle } from "~/feature/event/components/EventSectionTitle";
import { EventPageSections } from "~/feature/event/constants";
import type { IFAQItem } from "~/types/FAQ";

interface IFAQSectionProps {
  faqs: IFAQItem[];
}

export const FaqSection: FC<IFAQSectionProps> = ({ faqs }) => {
  if (!faqs.length) {
    return null;
  }

  return (
    <Stack component="section" id={EventPageSections.FAQ} sx={{
      gap: 1.5
    }}>
      <EventSectionTitle>Frequently asked questions</EventSectionTitle>
      <FAQAccordion items={faqs} />
    </Stack>
  );
};
